import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import Button from '@material-ui/core/Button';
import { navigate } from '@reach/router';
import { ADMIN_SHOP_COLLECTIONS } from '../../gql/admin-queries';
import { ADMIN_CREATE_COLLECTION } from '../../gql/admin-mutations';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing,
    marginRight: theme.spacing
  }
});

class AddCollection extends Component {
  state = {
    name: ''
  };

  render() {
    const { shopId } = this.props;
    return (
      <div>
        <Mutation
          mutation={ADMIN_CREATE_COLLECTION}
          variables={{ shopId }}
          update={(cache, { data: { createCollection } }) => {
            if (createCollection.id) {
              navigate(
                `/admin/${shopId}/inventory/collections/${createCollection.id}`
              );
              const data = cache.readQuery({
                query: ADMIN_SHOP_COLLECTIONS,
                variables: { id: shopId }
              });
              data.shop.collections.edges.unshift({
                node: {
                  ...createCollection
                },
                __typename: 'ShopCollectionEdge'
              });
              cache.writeQuery({
                query: ADMIN_SHOP_COLLECTIONS,
                variables: { id: shopId },
                data
              });
            }
          }}
        >
          {addCollection => (
            <Button
              data-cy="Collection-Add-New-Product-btn"
              color="primary"
              onClick={addCollection}
              variant="outlined"
            >
              New collection
            </Button>
          )}
        </Mutation>
      </div>
    );
  }
}

export default withStyles(styles)(AddCollection);
